import { usePaymentGroupStats } from '@/modules/common/hooks/data-hooks/usePaymentGroups';
import { useGetPayments } from '@/modules/payments/hooks/usePayments';
import { PaymentStatus, PaymentType } from '@/types/payment';
import { PaymentGroupType } from '@/types/payment-groups';
import { PaymentPageStage } from '../types';

type UsePaymentsCountsProps = {
  paymentType?: PaymentType;
  paymentGroupType?: PaymentGroupType;
};

export function usePaymentsCounts(opts: UsePaymentsCountsProps) {
  const { data: statsData, isLoading: isLoadingStats } = usePaymentGroupStats({
    type: opts.paymentGroupType,
  });
  const stats = statsData?.data;

  const { data: allPaymentsData, isLoading: isLoadingAllPayments } =
    useGetPayments(
      { paymentType: opts.paymentType },
      undefined,
      undefined,
      { createdAt: 'desc' },
      {
        enabled: true,
      },
    );

  const { data: awaitingPaymentsData, isLoading: isLoadingAwaitingPayments } =
    useGetPayments(
      {
        paymentType: opts.paymentType,
        status: [PaymentStatus.Pending, PaymentStatus.Authorized],
      },
      undefined,
      undefined,
      { createdAt: 'desc' },
      { enabled: true },
    );

  const countsByStage = {
    [PaymentPageStage.ALL]: allPaymentsData?.metadata?.total || 0,
    [PaymentPageStage.AWAITING_PAYMENT]:
      awaitingPaymentsData?.metadata?.total || 0,
    [PaymentPageStage.IN_PROGRESS]:
      stats?.find(item => item.stage === 'in_progress')?.count || 0,
    [PaymentPageStage.FAILED]:
      stats?.find(item => item.stage === 'failed')?.count || 0,
    [PaymentPageStage.COMPLETED]:
      stats?.find(item => item.stage === 'completed')?.count || 0,
  };

  const isLoadingCounts =
    isLoadingStats || isLoadingAllPayments || isLoadingAwaitingPayments;

  return {
    countsByStage,
    isLoadingCounts,
  };
}
